module.exports = __webpack_public_path__ + "static/img/10.d3a96c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/10.png
// module id = tkB8
// module chunks = 1